import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';

const MobileDevelopment = () => {
  const process = [
    { step: '01', title: 'Strategy', description: 'Define mobile app goals and user personas' },
    { step: '02', title: 'Design', description: 'Create beautiful and intuitive mobile interfaces' },
    { step: '03', title: 'Development', description: 'Build native or cross-platform mobile apps' },
    { step: '04', title: 'Launch', description: 'Deploy to App Store and Google Play' },
  ];

  const techStack = ['React Native', 'Flutter', 'Swift', 'Kotlin', 'Firebase', 'Redux', 'GraphQL'];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="pt-32 pb-20 bg-gradient-to-br from-slate-50 to-blue-50/30">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
              <h1 className="text-5xl font-heading font-bold text-slate-900 mb-6">
                Mobile <span className="text-gradient">Development</span>
              </h1>
              <p className="text-xl text-slate-600 mb-8">
                Create engaging mobile experiences with native and cross-platform apps that users love.
              </p>
              <Link to="/contact" className="bg-primary text-white px-8 py-4 rounded-full font-medium hover:shadow-xl hover:scale-105 transition-all duration-300 inline-flex items-center space-x-2" data-testid="service-cta-button">
                <span>Get Started</span>
                <ArrowRight className="w-5 h-5" />
              </Link>
            </motion.div>
            <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.2 }}>
              <img src="https://images.unsplash.com/photo-1590408867096-a6f7a9de19c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwbGFwdG9wJTIwY29kaW5nJTIwc2V0dXAlMjB3aGl0ZSUyMGRlc2t8ZW58MHx8fHwxNzY2NTE3NTc5fDA&ixlib=rb-4.1.0&q=85" alt="Mobile Development" className="rounded-2xl shadow-2xl" />
            </motion.div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-heading font-bold text-slate-900 mb-12 text-center">Our Process</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {process.map((item, index) => (
              <motion.div key={index} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.1 }} className="text-center">
                <div className="text-6xl font-bold text-primary/20 mb-4">{item.step}</div>
                <h3 className="text-xl font-heading font-bold text-slate-900 mb-2">{item.title}</h3>
                <p className="text-slate-600">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-heading font-bold text-slate-900 mb-12 text-center">Technology Stack</h2>
          <div className="flex flex-wrap justify-center gap-4">
            {techStack.map((tech, index) => (
              <motion.div key={index} initial={{ opacity: 0, scale: 0.8 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ delay: index * 0.05 }} className="bg-white px-6 py-3 rounded-full border border-slate-200 text-slate-700 font-medium">
                {tech}
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MobileDevelopment;
